import { RidangoReduxAction } from '@ridango/core';

import { RouteStopItem } from '../../schedule.model';
import { RouteStopsActions } from './route-stops.actions';

export const ROUTE_STOPS_STATE_KEY = 'routeStop';

export interface RouteStopsState {
    ids: number[];
    entities: RouteStopItem[];
    routePolyline: any;
    selectedId: number;
    loading: boolean;
    schedule: any;
    selectedDay: string;
}

export const ROUTE_STOPS_INITIAL_STATE: RouteStopsState = {
    ids: [],
    entities: [],
    routePolyline: null,
    selectedId: null,
    loading: false,
    schedule: {},
    selectedDay: 'today',
};

export function routeStopsReducer(
    state: RouteStopsState = ROUTE_STOPS_INITIAL_STATE,
    action: RidangoReduxAction
): RouteStopsState {
    switch (action.type) {
        case RouteStopsActions.FETCH_ROUTE_STOPS:
        case RouteStopsActions.FETCH_ROUTE_STOP_DEPATURES:
            return {
                ...state,
                loading: true,
            };
        case RouteStopsActions.FETCH_ROUTE_STOPS_SUCCESS:
            return {
                ...state,
                ...action.payload,
                loading: false,
            };
        case RouteStopsActions.FETCH_ROUTE_POLYLINE_SUCCESS:
            return {
                ...state,
                routePolyline: action.payload,
            };
        case RouteStopsActions.RESET_ROUTE_STOPS:
            return {
                ...state,
                ids: [],
                entities: [],
                routePolyline: null,
                selectedId: null,
            };
        case RouteStopsActions.FETCH_ROUTE_STOP_DEPATURES_SUCCESS:
            return {
                ...state,
                ...action.payload,
                loading: false,
            };
        case RouteStopsActions.SET_SELECTED_STOP:
            return {
                ...state,
                selectedId: action.payload,
            };
        case RouteStopsActions.SET_SELECTED_DAY:
            return {
                ...state,
                selectedDay: action.payload,
            };
    }

    return state;
}
